import React from 'react';

/** The supplied lockup artwork. Navy on transparent, so it is only used on light surfaces. */
export const LOGO_LOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/nTjBqcuuXgbjSwDzeQVhBn/Cavalla.png';
type LogoVariant = 'light' | 'reversed' | 'mark' | 'tile';
interface LogoProps {
  variant?: LogoVariant;
  className?: string;
}

/**
 * The Cavalla mark: an open crescent forming a C, crossed by a fine swoosh
 * that terminates in a single gold dot.
 */
export function CavallaMark({
  colour = '#123C73',
  className = ''
}: {
  colour?: string;
  className?: string;
}) {
  return <svg viewBox="0 0 100 100" className={className} aria-hidden="true" focusable="false" data-id="element-49" data-mp="13y079nkue86u">
      <path fill={colour} fillRule="evenodd" d="M50 50 m-46 0 a46 46 0 1 0 92 0 a46 46 0 1 0 -92 0 M63 50 m-38 0 a38 38 0 1 0 76 0 a38 38 0 1 0 -76 0" data-id="element-50" data-mp="18wjvxvqtly2w" />
      <path d="M13 70 C33 96 74 95 89 60" fill="none" stroke={colour} strokeWidth="3.4" strokeLinecap="round" data-id="element-51" data-mp="2ff8ba7rktmah" />
      <circle cx="89" cy="60" r="8" fill="#D4AF37" data-id="element-52" data-mp="1ww8sfw387a9t" />
    </svg>;
}
export function Logo({
  variant = 'light',
  className = ''
}: LogoProps) {
  if (variant === 'mark') {
    return <span className={`inline-flex ${className}`} role="img" aria-label="Cavalla Solution" data-id="element-53" data-mp="1nw2eya7j2aan">
        <CavallaMark className="h-9 w-9" data-id="element-54" data-mp="1iyk4gfdv3n0j" />
      </span>;
  }
  if (variant === 'tile') {
    return <span className={`inline-flex h-10 w-10 items-center justify-center rounded-[10px] bg-ink ${className}`} role="img" aria-label="Cavalla Solution" data-id="element-55" data-mp="1dzpormb6yekn">
        <CavallaMark colour="#FFFFFF" className="h-7 w-7" data-id="element-56" data-mp="148cu6my0daax" />
      </span>;
  }
  if (variant === 'light') {
    // The supplied artwork, cropped to the horizontal wordmark.
    return <span className={`inline-block h-9 overflow-hidden ${className}`} style={{
      width: '76px'
    }} role="img" aria-label="Cavalla Solution" data-id="element-57" data-mp="v7wtfl8ngh9r">
        <img src={LOGO_LOCKUP_URL} alt="" className="h-9 max-w-none object-left" style={{
        width: '106px'
      }} data-id="element-58" data-mp="glhdop8unf0m" />
      </span>;
  }
  return <span className={`inline-flex items-center gap-2.5 ${className}`} role="img" aria-label="Cavalla Solution" data-id="element-59" data-mp="li7szacty6kz">
      <CavallaMark colour="#FFFFFF" className="h-8 w-8 shrink-0" data-id="element-60" data-mp="bmekq3658z90" />
      <span className="font-display text-[22px] font-semibold leading-none tracking-[-0.01em] text-white" data-id="element-61" data-mp="bmmydxa3c8l9">
        Cavalla
      </span>
    </span>;
}